// extracted by mini-css-extract-plugin
export default {"container":"PollAttachmentIcon_container__vCwbj","icon":"PollAttachmentIcon_icon__ICx0h","image":"PollAttachmentIcon_image__rGnwX"};